/**
 * carousel.js
 * Script to create carousel components
 */

import ElementHelpers from '../../original/js/libraries/element-helpers';
import { Carousel as OrbitBase } from "../../original/js/components/carousel";
import $ from 'jquery';
import 'slick-carousel';

/**
* Declare constants
*/

export class Carousel extends OrbitBase {
  constructor(element) {
    super(element);
  }

  /**
   * Declare variants
   * Override added because of quickActions custom variant - DF097-152
   */
  get variants() {
    return {
      applicationProcess: 'application-process',
      blogOverviewCarousel: 'blog-overview--carousel',
      blogOverviewGrid: 'blog-overview--grid',
      blogOverviewTopic: 'blog-overview--topic',
      cards: 'cards',
      photo: 'photo',
      quote: 'quote',
      quickActions: 'quick-actions',
    };
  }

  /**
   * Initialize carousel
   * Override added because of quickActions custom variant - DF097-152
   */
  initializeCarousel() {
    let defaultSlickOptions = {
      arrows: false,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: ElementHelpers.maxWidthMobileViewports(),
          settings: {
            appendArrows: $(this.element).parents(
              `[${this.attributes.wrapper}]`
            ),
            arrows: true,
            draggable: false,
            slidesToShow: 3,
            slidesToScroll: 1
          }
        }
      ]
    };

    if (!this.element.classList.contains(this.classes.slickInitialized)) {
      this.removeHiddenClass();

      const initSlick = () => $(this.element).slick(defaultSlickOptions);
      const _this = this;

      switch (this.variant) {
        case this.variants.blogOverviewCarousel:
          defaultSlickOptions.responsive[0].settings.slidesToShow = 2;
          initSlick();
          break;

        case this.variants.blogOverviewGrid:
          defaultSlickOptions.responsive[0].settings = 'unslick';
          initSlick();
          break;

        case this.variants.blogOverviewTopic:
          initSlick();
          break;

        case this.variants.applicationProcess:
          defaultSlickOptions.responsive[0].settings.slidesToShow = 1;
          initSlick();
          break;

        case this.variants.photo: {
          this.sliderDots = this.element.nextElementSibling;
          defaultSlickOptions.dots = true;
          defaultSlickOptions.appendDots = this.sliderDots;
          defaultSlickOptions.responsive = [
            {
              breakpoint: ElementHelpers.maxWidthMobileViewports(),
              settings: {
                swipe: false
              }
            }
          ];

          if (!this.sliderDots) {
            return;
          }

          $(this.element).on(
            'beforeChange',
            function (event, slick, currentSlide, nextSlide) {
              if (!slickDots) {
                return;
              }

              const currentSlideEl = slides[nextSlide];

              const textColor = currentSlideEl.getAttribute(
                _this.attributes.textColor
              );

              slickDots.classList.remove(
                'slick-dots--dark',
                'slick-dots--light'
              );

              if (textColor === 'dark') {
                slickDots.classList.add('slick-dots--dark');
              } else {
                slickDots.classList.add('slick-dots--light');
              }
            }
          );

          initSlick();

          const slickDots = ElementHelpers.getElementByClassWithinElement(
            this.sliderDots,
            this.classes.slickDots
          );

          if (!slickDots) {
            return;
          }

          const slides = this.slides;
          const firstSlide = slides[0];

          const textColorFirstSlide = firstSlide.getAttribute(
            this.attributes.textColor
          );

          if (textColorFirstSlide === 'dark') {
            slickDots.classList.add('slick-dots--dark');
          } else {
            slickDots.classList.add('slick-dots--light');
          }

          break;
        }

        case this.variants.quote:
          defaultSlickOptions.dots = true;
          defaultSlickOptions.responsive = [
            {
              breakpoint: ElementHelpers.maxWidthMobileViewports(),
              settings: {
                swipe: false
              }
            }
          ];
          initSlick();
          break;

        case this.variants.cards:
          defaultSlickOptions.responsive[0].settings = 'unslick';
          initSlick();
          break;

        case this.variants.quickActions:
          // This variant is used for an optimizely test - DF097-152
          if (this.element.childNodes && this.element.childNodes.length <= 4) {
            defaultSlickOptions.responsive[0].settings.slidesToShow = 4;
          } else {
            defaultSlickOptions.responsive[0].settings.slidesToShow = 3;
          }
          initSlick();
          break;
        default:
          return;
      }
    }

    //if slider is carousel/topic/applicationprocess, set arrow heights equal to images in slider on resize window
    if (
      this.variant === this.variants.blogOverviewCarousel ||
      this.variants.blogOverviewTopic ||
      this.variants.applicationProcess ||
      this.variants.quickActions
    ) {
      const slickArrowNextButton = this.element.parentElement.querySelector(
        `.${this.classes.slickNext}.${this.classes.slickArrow}`
      );
      const slickArrowPrevButton = this.element.parentElement.querySelector(
        `.${this.classes.slickPrev}.${this.classes.slickArrow}`
      );
      const image = ElementHelpers.getElementByAttributeWithinElement(
        this.element,
        this.attributes.image
      );
      if (
        slickArrowNextButton !== null &&
        slickArrowPrevButton !== null &&
        image !== null
      ) {
        if (this.buttonId) {
          slickArrowNextButton.id = `button-next-${this.buttonId}`;
          slickArrowPrevButton.id = `button-prev-${this.buttonId}`;
        }

        // RXPIP-10592: Shows incorrect height of next/prev button on initial page load. Handle lazy loaded images.
        image.addEventListener('load', function () {
          slickArrowNextButton.style.height = `${image.offsetHeight}px`;
          slickArrowPrevButton.style.height = `${image.offsetHeight}px`;
        });

        setTimeout(function () {
          slickArrowNextButton.style.height = `${image.offsetHeight}px`;
          slickArrowPrevButton.style.height = `${image.offsetHeight}px`;
        }, 100);
      }
    }
  }
}
